import React from "react"
import { AppDetailRouteComponentProps } from "../../RouteProps"
import { AppAuthCheck } from "../../../Components/Common/AuthCheck/AppAuthCheck"
import { AppCustomizeTaskParameters } from "../../../Components/Views/Dashboard/Sections/AppDetail/Customize/Modes/Parameters/TaskSettings"

export function AppCustomizeTaskParametersRoute({
    match
}: AppDetailRouteComponentProps) {
    return (
        <AppAuthCheck {...match.params} scope="task-design:view">
            <AppCustomizeTaskParameters {...match.params} />
        </AppAuthCheck>
    )
}
